import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { Subscription } from 'rxjs';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { __APP_STORAGE_CART__ } from 'src/app/intefaces/const';
import { CurrencyService } from 'src/app/services/currency.service';
import { getCurrencySymbol } from '@angular/common';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  public cardNotes: Array<any> = [];
  public loading: boolean = false;
  public isLogin: boolean = false;
  public selectedCurrency: any;
  public currencySymbol;
  private currencySubscription: Subscription;
  @Output() changePrice = new EventEmitter<any>();
  
  @Input() readonly: boolean; 
  
  constructor(private cartService: CartService, private browserStorageService: BrowserStorageService, private authorizationService: AuthorizationService, private currencyService: CurrencyService) {
    this.isLogin = this.authorizationService.isLogin();
    this.cardNotes = [];
    
   }

  ngOnInit(): void {
    if(this.isLogin) {
      this.getMyCart();
    } else {
      this.getCartFromLocalStorage();
    }
    this.getCurrency();

    this.currencySubscription = this.currencyService.currencyChangeEmitter.subscribe((name: string) => {
        this.getCurrency();
    });
  }

  ngOnDestroy(): void {
    if(this.currencySubscription) {
      this.currencySubscription.unsubscribe();
    }
  }
  
  public createOrder() {
    const order = {
      payment_type: "transfer"
    }
    this.cartService.createOrder(order).subscribe(data => {
      console.log(data);
    }, err => console.log("err"));
  }


  public onCreateOrder() {
    this.createOrder();
  }

  public getCurrency() {
    setTimeout(() => {
      this.selectedCurrency = this.browserStorageService.get("_currency");
      this.currencySymbol = getCurrencySymbol(this.selectedCurrency, "narrow");
    }, 100);
  }

  private getCartFromLocalStorage(loader = true) {
    if(loader) {
      this.loading = true;
    }
    const cart = this.browserStorageService.get(__APP_STORAGE_CART__);
    this.cardNotes = JSON.parse(cart) || [];
    this.loading = false;
  }

  private deleteItem(item) {
    this.cartService.deleteItemFromCart(item).subscribe(data => {
      this.cartService.changeQuantity({ count: data.data.count });
    }, () => this.getMyCart(false));
  }
  
  public calculatePrice(items) {
    let total = 0;
    items.map(i => +i.price).forEach(element => {
      total+=element;
    });
   return total;
  }

  public onDeleteItem(item) {
    const index: number = this.cardNotes.indexOf(item);
    if (index !== -1) {
        this.cardNotes.splice(index, 1);
    }
    if(this.isLogin) {
      this.deleteItem(item);
    } else {
      this.browserStorageService.set(__APP_STORAGE_CART__, JSON.stringify(this.cardNotes));
    }
    this.changePrice.next(this.calculatePrice(this.cardNotes));
  }

  private getMyCart(loader = true) {
    if(loader) {
      this.loading = true;
    }
    this.cartService.getMyCart().subscribe(response => {
      this.cardNotes = response.data.cart;
      this.changePrice.next(this.calculatePrice(response.data.cart));
      if(loader) {
        this.loading = false;
      }
      
    }, () => this.loading = false);
  }
  


}
